import React from 'react';
import CashSources from '~Scenes/CashSources';
import { usePage } from '~Scenes/Handy/Context/PageProvider';

/**
 * Thin Handy wrapper around the shared POS CashSources scene.
 * Renders it in `isHandy` mode and wires the back button into the Handy
 * PageProvider navigation (CashSources' default back uses react-router, which
 * does not apply inside Handy). Mirrors EndOfDayWrapper.
 */
const CashManagementWrapper: React.FC = () => {
  const { navigateTo } = usePage();

  return <CashSources isHandy onBack={() => navigateTo('home')} />;
};

export default CashManagementWrapper;
